import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '..'

const BankAccountCategories = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <Path
      d="M22.403 7.715 12.838 1.67a.737.737 0 0 0-.787 0L2.486 7.715a.737.737 0 0 0 .394 1.36h19.13a.737.737 0 0 0 .393-1.36ZM20.752 9.516h-2.566a.737.737 0 0 0-.737.737V21.05c0 .407.33.738.737.738h2.566c.407 0 .737-.33.737-.738V10.253a.737.737 0 0 0-.738-.737ZM13.727 9.516h-2.565a.737.737 0 0 0-.737.737V21.05c0 .407.33.738.737.738h2.565c.407 0 .737-.33.737-.738V10.253a.737.737 0 0 0-.737-.737ZM6.652 9.516H4.087a.737.737 0 0 0-.737.737V21.05c0 .407.33.738.737.738h2.565c.407 0 .737-.33.737-.738V10.253a.737.737 0 0 0-.737-.737Z"
      fill="#8CBCFF"
    />
    <Path
      d="M6.652 9.516H5.37v12.27h1.282c.407 0 .737-.33.737-.737V10.253a.737.737 0 0 0-.737-.737Z"
      fill="#6AA9FF"
    />
    <Path
      d="M23.376 7.6H1.513C.756 7.6.14 8.218.14 8.975v1.41c0 .758.616 1.373 1.373 1.373h21.863c.757 0 1.373-.615 1.373-1.372V8.974c0-.757-.616-1.373-1.373-1.373ZM22.01 19.606H2.88a.737.737 0 0 0-.738.737v2.682c0 .407.33.737.737.737h19.13c.407 0 .737-.33.737-.737v-2.682a.737.737 0 0 0-.737-.737Z"
      fill="#54A0FF"
    />
    <Path
      d="M24.012 22.288H.877a.737.737 0 0 0-.737.737v2.682c0 .407.33.737.737.737h23.135c.407 0 .737-.33.737-.737v-2.682a.737.737 0 0 0-.737-.737Z"
      fill="#338DEF"
    />
    <Path
      d="M22.717 8.543a.737.737 0 0 1-.708.532h-9.565v-7.52c.137 0 .274.038.394.115L22.223 7.6l.18.114a.737.737 0 0 1 .314.828ZM20.752 9.516h-1.283v12.27h1.283c.407 0 .737-.33.737-.737V10.253a.737.737 0 0 0-.737-.737ZM13.727 9.516h-1.283v12.27h1.283c.407 0 .737-.33.737-.737V10.253a.737.737 0 0 0-.737-.737Z"
      fill="#6AA9FF"
    />
    <Path
      d="M24.749 8.974v1.41c0 .757-.616 1.373-1.373 1.373H12.444V7.601h10.932c.757 0 1.373.616 1.373 1.373ZM22.746 20.343v2.682c0 .407-.33.737-.737.737h-9.565v-4.156h9.565c.407 0 .737.33.737.737Z"
      fill="#338DEF"
    />
    <Path
      d="M24.749 23.025v2.682c0 .407-.33.737-.737.737H12.444v-4.156h11.568c.407 0 .737.33.737.737Z"
      fill="#338DEF"
    />
    <G clipPath="url(#a)">
      <Path
        d="M26.444 20.611a7.389 7.389 0 1 1-14.777 0 7.389 7.389 0 0 1 14.777 0Z"
        fill="#F0CD00"
      />
      <Path
        d="M26.444 20.611c0 3.989-3.16 7.24-7.113 7.384a7.389 7.389 0 0 1 0-14.768 7.389 7.389 0 0 1 7.113 7.384Z"
        fill="#FFDE50"
      />
      <Path
        d="M24.797 20.611a5.742 5.742 0 0 1-11.483.07v-.07a5.742 5.742 0 0 1 11.483 0Z"
        fill="#EAB540"
      />
      <Path
        d="m23.115 16.551-8.12 8.12a5.752 5.752 0 0 1-1.282-1.952 5.716 5.716 0 0 1-.399-2.037v-.07a5.742 5.742 0 0 1 9.801-4.06Z"
        fill="#EAB540"
      />
      <Path
        d="M24.797 20.611a5.742 5.742 0 0 1-6.066 5.733 5.742 5.742 0 0 0 0-11.466 5.742 5.742 0 0 1 6.066 5.733Z"
        fill="#F68E00"
      />
      <Path
        d="M21.337 18.853H20.33a2.425 2.425 0 0 0-.26-.631h1.266a.603.603 0 1 0 0-1.207h-5.699a.603.603 0 1 0 0 1.207h2.328c.462 0 .865.255 1.076.63h-3.404a.603.603 0 1 0 0 1.207h3.404a1.235 1.235 0 0 1-1.076.631h-2.328a.603.603 0 0 0-.439 1.017l3.28 3.482a.601.601 0 0 0 .853.026.603.603 0 0 0 .025-.853l-2.322-2.465h.93a2.445 2.445 0 0 0 2.366-1.838h1.006a.603.603 0 1 0 0-1.206Z"
        fill="#F68E00"
      />
      <Path
        d="M22.09 18.853h-1.005a2.425 2.425 0 0 0-.26-.631h1.266a.603.603 0 1 0 0-1.207h-5.699a.603.603 0 1 0 0 1.207h2.328c.462 0 .865.255 1.076.63h-3.404a.603.603 0 1 0 0 1.207h3.404a1.235 1.235 0 0 1-1.076.631h-2.328a.603.603 0 0 0-.439 1.017l3.28 3.482a.601.601 0 0 0 .853.026.603.603 0 0 0 .025-.853l-2.322-2.465h.931a2.445 2.445 0 0 0 2.365-1.838h1.006a.603.603 0 1 0 0-1.206Z"
        fill="#FFEA94"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path
          fill="#fff"
          transform="translate(11.667 13.222)"
          d="M0 0h14.778v14.778H0z"
        />
      </ClipPath>
    </Defs>
  </Svg>
)

export default BankAccountCategories
